var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDataBaseAlt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#data--base--alt_svg__clip0_61530_7312)",
    fill: "#45464F"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 6H5.25v1.5H9V6zM9 9H5.25v1.5H9V9zM9 12H5.25v1.5H9V12zM18.75 6H15v1.5h3.75V6zM18.75 9H15v1.5h3.75V9zM18.75 12H15v1.5h3.75V12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 3H3a1.502 1.502 0 00-1.5 1.5V21A1.502 1.502 0 003 22.5h18a1.502 1.502 0 001.5-1.5V4.5A1.502 1.502 0 0021 3zM3 4.5h8.25V21H3V4.5zM12.75 21V4.5H21V21h-8.25z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "data--base--alt_svg__clip0_61530_7312"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
}
export default SvgDataBaseAlt;